import { AppLoaderComponent } from './app-loader/app-loader.component';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutModule } from '@angular/cdk/layout';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { SharedModule } from './shared/shared.module';
import { BaseUrlService } from './api/base-url.service';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable, ObservableInput } from 'rxjs';
import { of } from 'rxjs';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { BaseComponent } from './core-app/base/base.component';
import { AddCatalogueComponent } from './core-app/catalogue/add-catalogue/add-catalogue.component';
import { CatalogueComponent } from './core-app/catalogue/catalogue.component';
import { DashboardComponent } from './core-app/dashboard/dashboard.component';
import { ErrorPageComponent } from './core-app/error-page/error-page.component';
import { DeleteWarningComponent } from './core-app/modals/warnings/delete-warning/delete-warning.component';
import { AccountSettingsComponent } from './core-app/settings/account-settings/account-settings.component';
import { NotificationsComponent } from './core-app/settings/notifications/notifications.component';
import { PasswordComponent } from './core-app/settings/password/password.component';
import { SettingsComponent } from './core-app/settings/settings.component';

export function load(http: HttpClient, config: BaseUrlService): (() => Promise<boolean>) {
  return (): Promise<boolean> => {
    return new Promise<boolean>((resolve: (a: boolean) => void): void => {
      http.get('./config.json')
      .pipe(
        map((x: BaseUrlService) => {
          config._userUrl = x._userUrl;
          config._authUrl = x._authUrl;
          resolve(true);
        }), 
        catchError((x: { status: number }, caught: Observable<void>): ObservableInput<{}> => {          
          if (x.status !== 404) {
            resolve(false);
          }

          config._userUrl = "http://cabsolonline.com:7575/cabsol/poi"; 
          config._authUrl = "http://comsoftltd.net/doiapptest/"; 

          resolve(true);
          return of({});
        })
      ).subscribe();
    });
  };
}



@NgModule({
  declarations: [
    AppComponent,
    AppLoaderComponent,
    DashboardComponent,
    BaseComponent,
    SettingsComponent,
    NotificationsComponent,
    AccountSettingsComponent,
    PasswordComponent,
    CatalogueComponent,
    CatalogueComponent,
    AddCatalogueComponent,
    DeleteWarningComponent,
    ErrorPageComponent,
   

  ],
  imports: [
    SharedModule,
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    BrowserAnimationsModule,
    LayoutModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: load,
      multi: true,
      deps: [
        HttpClient,
        BaseUrlService
      ]
    },
    { provide: LocationStrategy, useClass: HashLocationStrategy},
  
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: [] },

    SharedModule,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
